import React from 'react'
import {Navigation, Pagination, Autoplay} from 'swiper';
import { NavLink, Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';            
import 'swiper/css';
import './style.css';

const Interview_Swiper = (props) => {
  return (
    <>
        <div className="interview_main_box">
            <div className="interview_box">
            <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  spaceBetween={10}
                  slidesPerView={4}
                  navigation
                  pagination={{clickable:true}}
                  autoplay={true}
                  onSlideChange={() => console.log('slide change')}
                  onSwiper={(swiper) => console.log(swiper)}
            >
              <div className="interview_slider_box">


                  <SwiperSlide className='interview_slide'>
                      <a href={props.link1}><img className='interview_img' src={props.src1} alt={props.alt1}/></a>
                  </SwiperSlide>

                  <SwiperSlide className='interview_slide'>
                      <a href={props.link2}><img className='interview_img' src={props.src2} alt={props.alt2}/></a>
                  </SwiperSlide>

                  <SwiperSlide className='interview_slide'>
                      <a href={props.link3}><img className='interview_img' src={props.src3} alt={props.alt3}/></a>
                  </SwiperSlide>

                  <SwiperSlide className='interview_slide'>
                      <a href={props.link4}><img className='interview_img' src={props.src4} alt={props.alt4}/></a>
                  </SwiperSlide>

                  <SwiperSlide className='interview_slide'>
                      <a href={props.link5}><img className='interview_img' src={props.src5} alt={props.alt5}/></a>
                  </SwiperSlide>
                  
                  <SwiperSlide className='interview_slide'>
                      <a href={props.link6}><img className='interview_img' src={props.src6} alt={props.alt6}/></a>
                  </SwiperSlide>


            
              </div>


            </Swiper>

            </div>
        </div>  
    </>
  )
}

export default Interview_Swiper